(() => {
  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || "EUR";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "fr-FR", { style: "currency", currency }).format(Number(cents) / 100);
    } catch (_) {
      return `${(Number(cents) / 100).toFixed(2).replace(".", ",")} €`;
    }
  };

  const init = (shell) => {
    if (!shell || shell.dataset.pqReady === "true") return;
    shell.dataset.pqReady = "true";

    const header = shell.querySelector("[data-pq-header]");
    const menu = shell.querySelector("[data-pq-menu]");
    const setMenu = (open) => {
      menu?.classList.toggle("is-open", open);
      menu?.setAttribute("aria-hidden", String(!open));
      document.body.style.overflow = open ? "hidden" : "";
    };
    shell.querySelector("[data-pq-menu-open]")?.addEventListener("click", () => setMenu(true));
    shell.querySelectorAll("[data-pq-menu-close]").forEach((button) => button.addEventListener("click", () => setMenu(false)));
    menu?.querySelectorAll("nav a").forEach((link) => link.addEventListener("click", () => setMenu(false)));

    const onScroll = () => header?.classList.toggle("is-sticky", window.scrollY > 116);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    const range = shell.querySelector("[data-pq-range]");
    const before = shell.querySelector("[data-pq-before]");
    const handle = shell.querySelector("[data-pq-handle]");
    range?.addEventListener("input", () => {
      const value = `${range.value}%`;
      before.style.width = value;
      handle.style.left = value;
    });

    const mainImages = [...shell.querySelectorAll("[data-pq-main]")];
    const thumbs = [...shell.querySelectorAll("[data-pq-thumb]")];
    const count = shell.querySelector("[data-pq-count]");
    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const index = Number(thumb.dataset.pqThumb);
        thumbs.forEach((item) => item.classList.toggle("is-active", item === thumb));
        mainImages.forEach((image) => image.classList.toggle("is-active", Number(image.dataset.pqMain) === index));
        if (count) count.textContent = `0${index + 1} / 0${mainImages.length}`;
      });
    });

    const cartForm = shell.querySelector("[data-pq-cart-form]");
    cartForm?.querySelectorAll("[data-pq-cart-line]").forEach((line) => {
      const input = line.querySelector("[data-pq-cart-quantity]");
      const changeQuantity = (delta) => {
        if (!input) return;
        input.value = Math.max(0, Number(input.value || 0) + delta);
        cartForm.requestSubmit();
      };
      line.querySelector("[data-pq-cart-minus]")?.addEventListener("click", () => changeQuantity(-1));
      line.querySelector("[data-pq-cart-plus]")?.addEventListener("click", () => changeQuantity(1));
    });

    const form = shell.querySelector("[data-pq-product-form]");
    if (!form) return;
    const variantData = form.querySelector("[data-pq-variants]");
    const variants = variantData ? JSON.parse(variantData.textContent) : [];
    const idInput = form.querySelector("[data-pq-variant-id]");
    const priceTargets = shell.querySelectorAll("[data-pq-price], [data-pq-mobile-price]");
    const submitButton = form.querySelector("[data-pq-submit]");
    const submitLabel = form.querySelector("[data-pq-submit-label]");
    const quantityInput = form.querySelector("[data-pq-quantity]");

    const getSelectedOptions = () => [...form.querySelectorAll("[data-pq-option]")].map((group) => group.querySelector("[data-pq-value].is-active")?.dataset.pqValue);

    const updateVariant = () => {
      const selected = getSelectedOptions();
      const variant = variants.find((item) => item.options.every((option, index) => String(option) === String(selected[index])));
      if (!variant) {
        submitButton.disabled = true;
        submitLabel.textContent = "Combinaison indisponible";
        return;
      }
      idInput.value = variant.id;
      priceTargets.forEach((target) => { target.textContent = money(variant.price); });
      submitButton.disabled = !variant.available;
      submitLabel.textContent = variant.available ? `Ajouter — ${money(variant.price)}` : "Épuisé";
    };

    form.querySelectorAll("[data-pq-option]").forEach((group) => {
      const valueTarget = group.querySelector("[data-pq-option-value]");
      group.querySelectorAll("[data-pq-value]").forEach((button) => {
        button.addEventListener("click", () => {
          group.querySelectorAll("[data-pq-value]").forEach((item) => item.classList.toggle("is-active", item === button));
          if (valueTarget) valueTarget.textContent = button.dataset.pqValue;
          updateVariant();
        });
      });
    });

    form.querySelector("[data-pq-minus]")?.addEventListener("click", () => { quantityInput.value = Math.max(1, Number(quantityInput.value) - 1); });
    form.querySelector("[data-pq-plus]")?.addEventListener("click", () => { quantityInput.value = Math.min(5, Number(quantityInput.value) + 1); });

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (submitButton.disabled) return;
      const original = submitLabel.textContent;
      submitButton.disabled = true;
      submitLabel.textContent = "Ajout en cours…";
      try {
        const root = window.Shopify?.routes?.root || "/";
        const response = await fetch(`${root}cart/add.js`, { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) });
        if (!response.ok) throw new Error("cart");
        const cart = await fetch(`${root}cart.js`).then((result) => result.json());
        shell.querySelectorAll(".pq-cart-link b").forEach((bubble) => { bubble.textContent = cart.item_count; });
        const toast = shell.querySelector("[data-pq-toast]");
        toast?.classList.add("is-visible");
        window.setTimeout(() => toast?.classList.remove("is-visible"), 4500);
      } catch (_) {
        HTMLFormElement.prototype.submit.call(form);
        return;
      } finally {
        submitButton.disabled = false;
        submitLabel.textContent = original;
        updateVariant();
      }
    });

    updateVariant();
  };

  const boot = () => document.querySelectorAll(".pq-shell").forEach(init);
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", boot) : boot();
  document.addEventListener("shopify:section:load", boot);
})();
